import { render, staticRenderFns } from "./BrowseStrategiesFilters.vue?vue&type=template&id=c8500f22&scoped=true"
import script from "./BrowseStrategiesFilters.vue?vue&type=script&lang=js"
export * from "./BrowseStrategiesFilters.vue?vue&type=script&lang=js"
import style0 from "./BrowseStrategiesFilters.vue?vue&type=style&index=0&id=c8500f22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8500f22",
  null
  
)

export default component.exports